<template>
    <div class="container">
        <div class="col-md-12">
            <h2 class="text-center py-2">
                <b><i>{{ labels.title }}</i></b>
            </h2>
        </div>

        <b-container>
            <!-- Botones principales - Todos del mismo color (info) -->
            <b-row class="mb-4 justify-content-center">
                <b-col md="3" class="text-center">
                    <b-button @click="goToModalCompany()" variant="info" size="lg" class="w-100 action-btn">
                        <b-icon icon="building" class="me-2"></b-icon>
                        {{ labels.create }}
                    </b-button>
                </b-col>
                <b-col md="3" class="text-center">
                    <b-button @click="goToModalGrupo()" variant="info" size="lg" class="w-100 action-btn">
                        <b-icon icon="people" class="me-2"></b-icon>
                        {{ labels.createGroup }}
                    </b-button>
                </b-col>
                <b-col md="3" class="text-center">
                    <b-button @click="goToModalEditGrupo()" variant="info" size="lg" class="w-100 action-btn">
                        <b-icon icon="pencil-square" class="me-2"></b-icon>
                        {{ labels.editGroup }}
                    </b-button>
                </b-col>
            </b-row>

            <!-- Resultados de la consulta -->
            <div v-if="listCompany.length > 0">
                <b-row class="mb-4 align-items-end">
                    <!-- Buscador -->
                    <b-col md="4">
                        <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">{{ labels.search }}</label>
                        <b-form-input 
                            v-model="searchCompany" 
                            @input="searchOnTableCompany" 
                            class="form-control"
                            :placeholder="labels.search + '...'">
                        </b-form-input>
                    </b-col>

                    <b-col md="2" class="d-flex align-items-end">
                        <b-button @click="clearSearch" variant="outline-secondary" class="w-100" style="height: 38px;">
                            <b-icon icon="arrow-counterclockwise" class="me-2"></b-icon>
                            {{ labels.clear }}
                        </b-button>
                    </b-col>

                    <!-- Selector de registros -->
                    <b-col md="3" class="d-flex align-items-end">
                        <b-form-select v-model="itemLimit" :options="limitOptions" size="md" style="width: 100%;"
                            @change="resetVisibleItems">
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Contador -->
                <b-row class="mb-3">
                    <b-col md="12">
                        <div class="text-muted text-center">
                            {{ labels.showing }} <strong>{{ visibleItems.length }}</strong> {{ labels.of }}
                            <strong>{{ listCompany.length }}</strong> {{ labels.records }}
                        </div>
                    </b-col>
                </b-row>

                <!-- Tabla -->
                <b-row>
                    <b-col md="12">
                        <div class="table-responsive custom-scroll-container" ref="scrollContainer">
                            <table class="table table-hover table-bordered">
                                <thead style="background-color: #4a90e2;">
                                    <tr>
                                        <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">{{ labels.name }}</th>
                                        <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">{{ labels.currency }}</th>
                                        <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">{{ labels.acronym }}</th>
                                        <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">{{ labels.code }}</th>
                                        <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">{{ labels.group }}</th>
                                        <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">{{ labels.nit }}</th>
                                        <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">{{ labels.subsidiary }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="company in visibleItems" :key="company.id" @click="editarCompany(company.id)" class="clickable-row">
                                        <td class="text-left"><strong class="text-dark">{{ company.nombre }}</strong></td>
                                        <td class="text-center">{{ getCurrency(company.id_moneda) }}</td>
                                        <td class="text-center">{{ company.acronym }}</td>
                                        <td class="text-center">{{ company.codigo || '-' }}</td>
                                        <td class="text-center">{{ getGruposNombres(company.id_grupos) }}</td>
                                        <td class="text-center">{{ company.identificacion || '-' }}</td>
                                        <td class="text-center">
                                            <b-button @click.stop="infoCompany(company.id)" variant="info" size="sm"
                                                class="subsidiary-btn">
                                                <md-icon style="color:white;">menu</md-icon>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- Mensaje cuando no hay datos -->
            <div v-else class="mt-4 text-center">
                <div class="h4 text-muted">
                    <b-icon icon="inbox" class="me-2"></b-icon>
                    {{ labels.noData }}
                </div>
            </div>
        </b-container>

        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
        </div>

        <!-- Modales -->
        <NewCompany :showDialog="showDialog" @clicked="closeModal" @companyCreated="handleCompanyUpdated"/>
        <Edit :showDialogEdit="showDialogEdit" @clicked="closeModal" :Item="itemSelected" @companyUpdated="handleCompanyUpdated"/>
        <ListSubsidiary :showDialogInfo="showDialogInfo" @clicked="closeModal" :Item="listadoSubsidiary" :companyName="datosCompany"/>
        <NewGrupo :showDialogGrupo="showDialogGrupo" @clicked="closeModal" @grupoCreado="recargarGrupos"/>
        <EditGrupo :showDialogEditGrupo="showDialogEditGrupo" @clicked="closeModalEditGrupo" @grupoActualizado="recargarGrupos"/>
    </div>
</template>

<script>
    import Company from '@/services/Company'
    import Currency from '@/services/Currency'
    import Subsidiary from '@/services/Subsidiary'
    import NewCompany from '../company/NewCompany.vue'
    import Edit from '../company/Edit.vue'
    import ListSubsidiary from '../company/ListSubsidiary.vue'
    import NewGrupo from '../company/NewGrupo.vue'
    import EditGrupo from '../company/EditGrupo.vue'
    import Grupo from '@/services/Grupo'

    const toLower = (text) => {
        return text.toString().toLowerCase();
    };

    const searchByCompany = (items, term) => {
        if (term) {
            const termLower = toLower(term);
            return items.filter((item) => {
                if (item.nombre && toLower(item.nombre).includes(termLower)) return true;
                if (item.acronym && toLower(item.acronym).includes(termLower)) return true;
                if (item.codigo && toLower(item.codigo).includes(termLower)) return true;
                if (item.identificacion && toLower(item.identificacion).includes(termLower)) return true;
                return false;
            });
        }
        return items;
    };

    export default {
        name: "Manage",

        components: {
            NewCompany,
            Edit,
            ListSubsidiary,
            NewGrupo,
            EditGrupo
        },

        data: () => ({
            searchCompany: null,
            isLoading: false,
            listCompany: [],
            listCurrency: [],
            showDialog: false,
            showDialogGrupo: false,
            showDialogEditGrupo: false,
            showDialogEdit: false,
            showDialogInfo: false,
            itemSelected: {},
            listadoSubsidiary: [],
            datosCompany: {},
            listGrupos: [],
            listCompanyOrigen: [],
            itemLimit: 100,
            visibleItems: [],
            limitOptions: [
                { value: 100, text: '100 registros' },
                { value: 200, text: '200 registros' },
                { value: 500, text: '500 registros' },
                { value: 0, text: 'Mostrar todo' }
            ]
        }),

        computed: {
            labels() {
                if (this.$store.state._language == "es-ES") {
                    return {
                        title: "COMPAÑÍAS",
                        create: "CREAR COMPAÑÍA",
                        createGroup: "CREAR GRUPO",
                        editGroup: "EDITAR GRUPO",
                        search: "Buscar",
                        clear: "Limpiar",
                        showing: "Mostrando",
                        of: "de",
                        records: "registros",
                        name: "Nombre",
                        currency: "Moneda",
                        acronym: "Acrónimo",
                        code: "Código",
                        group: "Grupo",
                        nit: "NIT",
                        subsidiary: "Subsidiarias",
                        viewSubsidiaries: "Ver Subsidiarias",
                        noData: "No hay compañías registradas"
                    }
                } else {
                    return {
                        title: "COMPANIES",
                        create: "CREATE COMPANY",
                        createGroup: "CREATE GROUP",
                        editGroup: "EDIT GROUP",
                        search: "Search",
                        clear: "Clear",
                        showing: "Showing",
                        of: "of",
                        records: "records",
                        name: "Name",
                        currency: "Currency",
                        acronym: "Acronym",
                        code: "Code",
                        group: "Group",
                        nit: "Tax ID",
                        subsidiary: "Subsidiaries",
                        viewSubsidiaries: "View Subsidiaries",
                        noData: "No companies registered"
                    }
                }
            }
        },

        methods: {
            goToModalCompany() {
                this.showDialog = true;
            },
            
            goToModalGrupo() {
                this.showDialogGrupo = true;
            },
            
            goToModalEditGrupo() {
                if (this.listGrupos.length === 0) {
                    this.$toast.warning(this.$store.state._language == "es-ES" 
                        ? "No hay grupos disponibles para editar" 
                        : "No groups available to edit");
                    return;
                }
                // Simplemente abrimos el modal, el componente EditGrupo se encarga de mostrar la lista
                this.showDialogEditGrupo = true;
            },
            
            recargarGrupos() {
                this.cargarGrupos();
                this.actualizarListaCompany();
            },
            
            async cargarGrupos() {
                try {
                    const result = await Grupo.getAllGrupos();
                    this.listGrupos = result.data.grupos;
                } catch (error) {
                    console.error("Error loading grupos:", error);
                }
            },
            
            editarCompany(id) {
                this.showDialogEdit = true;
                Company.getCompanyById(id)
                    .then((rta) => {
                        this.itemSelected = rta.data.company[0];
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$toast.error("Error al cargar la compañía");
                    });
            },
            
            handleCompanyUpdated() {
                this.actualizarListaCompany();
            },
            
            actualizarListaCompany() {
                this.isLoading = true;
                Company.getAllCompanies()
                    .then((result) => {
                        this.listCompany = result.data.companies;
                        this.listCompanyOrigen = [...this.listCompany];
                        this.resetVisibleItems();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$toast.error("Error al cargar las compañías");
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            
            infoCompany(id) {
                Subsidiary.getAllSubsidiaryByComp(id)
                    .then((res) => {
                        this.listadoSubsidiary = res.data.subsidiary;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.listadoSubsidiary = [];
                    });
                    
                Company.getCompanyById(id)
                    .then((res) => {
                        this.datosCompany = res.data.company[0];
                    })
                    .catch((err) => {
                        console.log(err);
                    });
                    
                this.showDialogInfo = true;
            },
            
            closeModal(value) {
                this.showDialog = value;
                this.showDialogGrupo = value;
                this.showDialogEdit = value;
                this.showDialogInfo = value;
            },
            
            closeModalEditGrupo(value) {
                this.showDialogEditGrupo = value;
            },
            
            clearSearch() {
                this.searchCompany = '';
                this.listCompany = [...this.listCompanyOrigen];
                this.resetVisibleItems();
            },
            
            searchOnTableCompany() {
                if (this.searchCompany) {
                    this.listCompany = searchByCompany(this.listCompanyOrigen, this.searchCompany);
                } else {
                    this.listCompany = [...this.listCompanyOrigen];
                }
                this.resetVisibleItems();
            },
            
            resetVisibleItems() {
                if (this.itemLimit === 0) {
                    this.visibleItems = [...this.listCompany];
                } else {
                    this.visibleItems = this.listCompany.slice(0, this.itemLimit);
                }
            },
            
            getGruposNombres(id_grupos) {
                if (!id_grupos) return 'Sin grupo';
                
                const gruposIds = id_grupos.split(',').map(id => parseInt(id.trim()));
                const gruposNombres = gruposIds.map(id => {
                    const grupo = this.listGrupos.find(g => g.id === id);
                    return grupo ? grupo.nombre : 'Grupo desconocido';
                });
                
                return gruposNombres.join(', ');
            },
            
            getCurrency(id) {
                let objMoneda = this.listCurrency.find((obj) => obj.id === id);
                return objMoneda?.nombre || 'N/A';
            }
        },
        
        mounted() {
            this.isLoading = true;
            
            Promise.all([
                Company.getAllCompanies(),
                Currency.getAllCurrency(),
                Grupo.getAllGrupos()
            ])
            .then(([companiesRes, currencyRes, gruposRes]) => {
                this.listCompany = companiesRes.data.companies;
                this.listCompanyOrigen = [...this.listCompany];
                this.listCurrency = currencyRes.data.currency;
                this.listGrupos = gruposRes.data.grupos;
                this.resetVisibleItems();
            })
            .catch((error) => {
                console.error("Error loading initial data:", error);
                this.$toast.error("Error al cargar los datos iniciales");
            })
            .finally(() => {
                this.isLoading = false;
            });
        }
    }
</script>

<style scoped>
.container {
    padding: 20px;
}

h2 {
    color: #2c3e50;
    font-weight: bold;
    margin-bottom: 30px;
}


.table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}

.table thead th {
    background-color: #4a90e2;
    color: white;
    text-align: center;
    vertical-align: middle;
    padding: 12px;
    font-weight: 600;
    border: none;
}

.table tbody td {
    text-align: center;
    vertical-align: middle;
    padding: 10px;
}

.table tbody .text-left {
    text-align: left !important;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background-color: #f8f9fa;
}

.table-hover tbody tr:hover {
    background-color: #f5f5f5;
}

.table-bordered {
    border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
    border: 1px solid #dee2e6;
}

.loadingSpinner {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    justify-content: center;
    align-items: center;
}

.loadingSpinner.active {
    display: flex;
}


.custom-scroll-container {
    max-height: 600px;
    overflow-y: auto;
}

.table-responsive {
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Responsive */
@media (max-width: 768px) {
    .container {
        padding: 10px;
    }
    
    .action-btn {
        font-size: 0.9rem;
        padding: 8px 12px;
        margin-bottom: 10px;
    }
    
    .table {
        font-size: 12px;
    }
    
    .table thead th {
        padding: 8px;
        font-size: 11px;
    }
    
    .table tbody td {
        padding: 6px;
    }

}
</style>